// extracted by mini-css-extract-plugin
export default {"radioList":"Health_radioList__lIISW","radioOption":"Health_radioOption__WIafn","buttonFooter":"Health_buttonFooter__xPcNu","buttonFooterFixed":"Health_buttonFooterFixed__OSf+R"};